import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import RedirectFromItsme from "./pages/redirect-from-itsme/redirect-from-itsme";
import LoginPage from "./pages/login/login";
import SelectOffice from "./pages/select-office/select-office";
import Onboarding from "./pages/onboarding/onboarding";
import GlobalStyle from "components/theme/styles";
import Information from "pages/Information";
import { Grid } from "@material-ui/core";
import PortimaHeader from "components/header/header";
import useForceUpdate from "hooks/useForceUpdate";
import i18next from "i18next";
import Footer from "components/footer/footer";
import "App.scss";

const App = (): React.ReactElement => {
    const forceUpdate = useForceUpdate();
    const handleChangeLanguage = (language: string) => {
        i18next.changeLanguage(language).then(() => {
            forceUpdate(); // Update the page to set the new language selected
        });
    };

    return (
        <Grid>
            <Grid item xs={12}>
                <PortimaHeader onChangeLanguage={(language: string) => handleChangeLanguage(language)} />
            </Grid>
            <GlobalStyle />
            <Grid className="page-body">
                <BrowserRouter>
                    <Switch>
                        <Route exact path="/onboarding" component={Onboarding} />
                        <Route exact path="/information" component={Information} />
                        <Route exact path="/redirect-from-itsme/:purpose" component={RedirectFromItsme} />
                        <Route exact path="/login" component={LoginPage} />
                        <Route exact path="/select-office" component={SelectOffice} />
                        <Route exact path="*" component={LoginPage} />
                    </Switch>
                </BrowserRouter>
            </Grid>
            <Footer />
        </Grid>
    );
};

export default App;
